const makeTable = (items) => `
    <!DOCTYPE html>
    <html lang="ru">
    <html>
      <head>
        <meta charset="UTF-8">
        <title>Лицензии</title>
        <style>
          h1 {
            text-align: center;
            margin-bottom: 20px;
          }
          table {
            width: 100%;
            font-family: 'Lucida Console', monospace;
            border-collapse: collapse;
          }  
          th, td {
            border: 1px dashed #000;
            padding: 10px;
            text-align: center;
          }  
          th {
            background-color: #f5f5f5;
            width: 33%;
          }  
          tr {
            height: 50px;
          }   
          .print-hint {
            text-align: right;
            font-size: 12px;
            color: #555;
            margin-bottom: 15px;
          } 
          @media print {
            body {
              padding: 0;
            }
            tr {
              page-break-inside: avoid;
            }  
          }  
        </style>

      </head>
      <body>
        <h1>Сгенерированные лицензии</h1>
        <p class="print-hint">Для печати нажмите CTRL + P</p>
        <table>
          <thead>
            <tr>
              <th>Заводской номер</th>
              <th>Лицензия</th>
              <th>Предмет лицензии</th>
            </tr>
          </thead>
          <tbody id="table-body">` +
            items + 
          `</tbody>    
        </table>  

        

      </body>
    </html>`;

export { makeTable };
